import OrganizationRegistrationStepDot from './components/OrganizationRegistrationStepDot';
import { OrganizationRegistrationStepperProps } from './types';

const OrganizationRegistrationStepper = (props: OrganizationRegistrationStepperProps) => {
  const { stage } = props;

  return (
    <div className="flex items-center justify-center gap-1 pt-1">
      <OrganizationRegistrationStepDot
        isActive={stage === 'lookup'}
        isDone={stage === 'review'}
        label="Поиск по ИНН"
        number={1}
      />
      <span className="h-px w-5 bg-muted-foreground" />
      <OrganizationRegistrationStepDot
        isActive={stage === 'review'}
        isDone={false}
        label="Реквизиты"
        number={2}
      />
    </div>
  );
};

export default OrganizationRegistrationStepper;